import {
  ExecutionTiersData,
  SupportedPublicPerformanceTierKey,
} from "../useGetPerformanceTiers";
import { ActiveContext } from "../../ContextSwitcher/store";

export type GetDefaultPerformanceKey = (
  activeContext: ActiveContext | undefined,
  performanceTiers: ExecutionTiersData[]
) => SupportedPublicPerformanceTierKey | undefined;

export const getDefaultPerformanceKey: GetDefaultPerformanceKey = (
  activeContext,
  performanceTiers
) => {
  if (!activeContext || performanceTiers.length === 0) {
    return undefined;
  }

  if (activeContext.serviceTier.hasPaidPlanSubscription) {
    // find the first paid performance tier, performanceTiers is already sorted by credits asc
    const firstPaidPerformanceTier = performanceTiers.find(
      ({ credits }) => credits > 0
    );

    return (
      firstPaidPerformanceTier?.publicPerformanceTierKey ??
      performanceTiers[0].publicPerformanceTierKey
    );
  }

  return performanceTiers[0].publicPerformanceTierKey;
};
